import React, { Component } from "react"
import { NavLink } from "react-router-dom"

class Hamburger extends Component {
  constructor(props){
    super(props);
    this.state={
      hamburgerOpen: false,
    }
  }

  handleHamburgerClick() {
    this.setState({hamburgerOpen:!this.state.hamburgerOpen});
  }

  handleLinkClick() {
    this.setState({hamburgerOpen: false});
  }

  render() {
    const { dataHamburger } = this.props;
    const hamburgerOpen = this.state.hamburgerOpen;

    return(
      <div className="flex justify-end">
        <div open={this.state.hamburgerOpen} onClick={()=>this.handleHamburgerClick()} className="relative w-8 h-4.5 cursor-pointer z-50">
          <span className={`absolute top-0 left-0 right-0 h-0.5 bg-black transition duration-500 ease-in-out ${hamburgerOpen ? "transform rotate-45 translate-y-2" : ""}`}></span>
          <span className={`absolute top-2 left-0 right-0 h-0.5 bg-black transition duration-500 ease-in-out ${hamburgerOpen ? "opacity-0 transform translate-x-4" : "opacity-100"}`}></span>
          <span className={`absolute top-4 left-0 right-0 h-0.5 bg-black transition duration-500 ease-in-out ${hamburgerOpen ? "transform -rotate-45 -translate-y-2" : ""}`}></span>
        </div>
        <div className={`fixed top-0 right-0 bottom-0 flex items-center bg-white p-8 w-64 transition duration-500 ease-in-out transform ${hamburgerOpen ? "translate-x-0" : "translate-x-full"}`} open={this.state.hamburgerOpen}>
          <ul className="m-0 items-center">
            {dataHamburger && dataHamburger.items && dataHamburger.items.map(prop => {
              return (
                <li className={`nav-item mx-4 my-4 ${prop.id === '' ? "" : ""}`} key={prop.id}>
                  <NavLink className="nav-link active" to={'/'+prop.object_slug} alt={prop.title} onClick={() => this.handleLinkClick()} activeClassName="font-semibold underlined">
                    {prop.title}
                  </NavLink>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Hamburger
